<!--
  状态
  lovi 2020-1-11
-->
<template>
  <div class="w100 childRoute-wrapper">
    <van-nav-bar
      :title="
        bankId ? $t('bankCard.editBankCard') : $t('bankCard.bindingBankCard')
      "
    />

    <div class="status-wrap">
      <img src="@/assets/images/public/icon_success@2x.png" />
      <h3>
        {{
          bankId
            ? $t("bankCard.editBankCardSuccess")
            : $t("bankCard.bindingBankCardSuccess")
        }}
      </h3>
    </div>

    <div class="button-wrap">
      <van-button block type="primary" @click="_back">
        {{ $t("common.confirm") }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bankId: {
      type: Number,
      default: function() {
        return 0;
      }
    }
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.status-wrap {
  padding-top: 50px;
  padding-bottom: 30px;
  text-align: center;
  img {
    width: 64px;
  }
  h3 {
    margin-top: 10px;
    font-size: 24px;
    font-weight: 500;
  }
}

.list-wrap {
  padding-top: 10px;
  padding-left: 15px;
  ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px 10px 0;
    line-height: 24px;
    border-bottom: 1.1px solid #e4e4e4;
    .li-l {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      .icon-copy {
        margin-left: 10px;
        width: 10px;
        height: 12px;
        background: url("~@/assets/images/public/icon_copy@2x.png") no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>
